import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const ConfirmEmailNotification = lazy(
  () => import('@pages/dashboard/ConfirmEmailNotification/index'),
);

export const ConfirmEmailNotificationRoutes: RouteObject[] = [
  {
    path: '/email-confirmation',
    element: (
      <React.Suspense>
        <ConfirmEmailNotification />
      </React.Suspense>
    ),
  },
];
